export default __webpack_public_path__ + "static/careers-benefits-block1-icon11.url-1539d6a7fd484865ad0c33368abc46bc.svg";